const questions = [
  {
    id: 1,
    title: "How can I change the theme of Device Info?",
    info: "You just need to open the settings by touching the three-dot menu. Then you can find the dark theme and also the accent colors to choose from.",
  },
  {
    id: 2,
    title: "How to copy specific information?",
    info: "Open the app and then, touch and hold the required information. Then it will be copied to the clipboard. Now you can paste it anywhere.",
  },
  {
    id: 3,
    title: "Why there are so many permissions?",
    info: "Most of the permissions are needed for the tests to work. We can guarantee that Device Info cannot access any personal information.",
  },
  {
    id: 4,
    title: "Why the cameras show incorrect megapixels?",
    info: "Because of the restrictions of the Android OS, sometimes the megapixels which the device Info shows can be incorrect. But the features are 100% accurate.",
  },
  {
    id: 5,
    title: "Is there a widget?",
    info: "Yes. Device info has a customizable widget which looks professional and it updates automatically within some intervals",
  },
  {
    id: 6,
    title: "How can I export data?",
    info: "Go to the 3 dot menu and open Export data. Now you can customize your report and finally export it as a PDF or Text file.",
  },
];
export default questions;
